import { type PaymentToSchedule } from '../models';
import { type Transfer } from '../transfer';

const COUNTERPARTY_REASONS_TO_DISABLE_UPDATE_BUTTON = [
  'currencyNotSupported',
  'countryNotSupported',
] as const;

export function getIsCountryAndCurrencySupported(
  paymentToSchedule: PaymentToSchedule | Transfer,
) {
  // Guard case so it doesn't throw an error if the payment method is not present
  if (!paymentToSchedule.paymentMethods?.wiretransfer) {
    return true;
  }

  const paymentToScheduleWiretransferEligibility =
    paymentToSchedule.paymentMethods.wiretransfer;

  const isNotSupported =
    !paymentToScheduleWiretransferEligibility?.active &&
    COUNTERPARTY_REASONS_TO_DISABLE_UPDATE_BUTTON.some((reason) =>
      paymentToScheduleWiretransferEligibility?.reasons.counterparty.includes(
        reason,
      ),
    );

  return !isNotSupported;
}
